import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Menu,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBuildingWarehouse,
  IconCalendar,
  IconCheck,
  IconFileExport,
  IconRefresh,
  IconSearch,
  IconStatusChange,
  IconUser,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_Row,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import { repositoryDelivery } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { changeSearchValue } from "../../../_base/helper/FunctionHelper";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { BASE_API_DELIVERY } from "../../../config";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  getTblDmEmployeeAll,
  getTblDMInventory,
} from "../../../service/getSelectApi";
import UpdateListStatus from "./UpdateListStatus";
import UpdateStatus from "./UpdateStatus";
import { useNavigate } from "react-router-dom";

const ListPromotionByItem = () => {
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);

  const [search, setSearch] = useState<any>({});
  const [keySearch, setKeySearch] = useDebouncedState<string>("", 300);
  const [selectMenu, setSelectMenu] = useState<number>(-1);
  const [openMenu, setOpenMenu] = useState<boolean>(false);

  const [dataEmployee, setDataEmployee] = useState<ComboboxItem[]>([]);
  const [dataInventory, setDataInventory] = useState<ComboboxItem[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "maSp",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue && renderedCellValue !== null ? (
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "tenSp",
        header: "Tên sản phẩm",
        size: 350,
      },
      {
        accessorKey: "maCtkm",
        header: "Mã CTKM",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue && renderedCellValue !== null ? (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                variant="dot"
                size="md"
                color={renderedCellValue === null ? "red" : "blue"}
                onDoubleClick={() => {
                  navigate("/config-system/detail-promotion", {
                    state: { id: row.original.idCtkm },
                  });
                }}
                style={{ cursor: "pointer" }}
              >
                {renderedCellValue}
              </Badge>
            </Tooltip>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "tenCtkm",
        header: "Tên CTKM",
        size: 350,
      },
      {
        accessorKey: "slTon",
        header: "Số lượng tồn",
      },
      {
        accessorKey: "maKho",
        header: "Mã kho",
      },
      {
        accessorKey: "giaBanLe",
        header: "Giá bán lẻ",
        Cell: ({ renderedCellValue }) => (
          <Text size="12.5px" fw={500}>
            {Number(renderedCellValue)?.toLocaleString()} đ
          </Text>
        ),
      },
      {
        accessorKey: "giaWeb",
        header: "Giá web",
        Cell: ({ renderedCellValue }) => (
          <Text size="12.5px" fw={500}>
            {Number(renderedCellValue)?.toLocaleString()} đ
          </Text>
        ),
      },
      {
        accessorKey: "ttDuyet",
        header: "Trạng thái duyệt",
        Cell: ({ row }) => (
          <>
            <Badge
              color={getColorStatusCTKM(
                row.original.ttDuyet,
                row.original.ngayHieuLuc,
                row.original.ngayHetHan
              )}
            >
              {getValueStatus(row.original.ttDuyet?.toString() ?? "")}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "tt",
        header: "Trạng thái CTKM",
        Cell: ({ row }) => (
          <>
            <Badge
              color={getColorStatusCTKM(
                row.original.ttDuyet,
                row.original.ngayHieuLuc,
                row.original.ngayHetHan
              )}
            >
              {getStatus2(
                row.original.ttDuyet,
                row.original.ngayHieuLuc,
                row.original.ngayHetHan
              )}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "ngayHieuLuc",
        header: "Ngày hiệu lực",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
      {
        accessorKey: "ngayHetHan",
        header: "Ngày hết hạn",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
      {
        accessorKey: "maHangChinh",
        header: "Mã hàng chính",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue && renderedCellValue !== null ? (
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              color={renderedCellValue === null ? "red" : "yellow"}
            >
              {renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      // {
      //   accessorKey: "lisItemGift",
      //   header: "Quà tặng",
      // },
      // {
      //   accessorKey: "lisItemGift1",
      //   header: "Quà tặng 1",
      // },
      // {
      //   accessorKey: "lisItemAddOn",
      //   header: "Sản phẩm kèm theo",
      // },
      {
        accessorKey: "tenNguoiDuyet",
        header: "Người duyệt",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {row.original.maNguoiDuyet} - {row.original.tenNguoiDuyet}
          </Text>
        ),
      },
      {
        accessorKey: "ngayDuyet",
        header: "Ngày duyệt",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
      {
        accessorKey: "tenNguoiTao",
        header: "Người tạo",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {row.original.maNguoiTao} - {row.original.tenNguoiTao}
          </Text>
        ),
      },
      {
        accessorKey: "ngayTao",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnFilter: false,
        enableResizing: false,
        enableClickToCopy: false,
        size: 70,
        Cell: ({ row }) => (
          <Flex justify={"center"} align={"center"}>
            <Menu
              position="left"
              closeOnItemClick={false}
              opened={row.index === selectMenu}
              onChange={() => setSelectMenu(row.index)}
            >
              <Menu.Target>
                <Tooltip label="Cập nhật trạng thái CTKM">
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="teal"
                    size={"md"}
                    p={2}
                  >
                    <IconRefresh stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
              </Menu.Target>
              <Menu.Dropdown>
                <UpdateStatus
                  codes={[row.original.maCtkm]}
                  status={row.original.ttDuyet}
                  fetchData={fetchData}
                  setSelectMenu={setSelectMenu}
                />
              </Menu.Dropdown>
            </Menu>
          </Flex>
        ),
      },
    ],
    [selectMenu, dataEmployee]
  );

  const getColorStatusCTKM = (
    status: string,
    effDate: Date,
    expDate: Date
  ): string => {
    const now = new Date();
    const effectiveDate = effDate ? new Date(effDate) : null;
    const expirationDate = expDate ? new Date(expDate) : null;
    switch (status) {
      case "2": // Đã duyệt
        if (effectiveDate && expirationDate) {
          if (now >= effectiveDate && now <= expirationDate) {
            return "teal"; // Đang chạy
          } else if (now > expirationDate) {
            return "gray"; // Hết hiệu lực
          } else if (now < effectiveDate) {
            return "teal.4"; // Hết hiệu lực
          }
          return "teal";
        }
        return "blue"; // Đang xét duyệt
      case "3": // Dừng duyệt
        return "yellow"; // Đang xét duyệt (có thể chỉnh sửa, không cho xóa)
      case "4": // Từ chối
        return "red"; // Không áp dụng (có thể sửa, không cho xóa)
      case "5": // Hủy duyệt
        return "blue"; // Chưa áp dụng (có thể sửa, không cho xóa)
      default: // Chưa duyệt
        return "blue"; // Đang xét duyệt (có thể chỉnh sửa, có thể xóa)
    }
  };

  const getValueStatus = (value: string) => {
    switch (value) {
      case "1":
        return "Chưa duyệt";
      case "2":
        return "Đã duyệt";
      case "3":
        return "Tạm dừng";
      case "4":
        return "Từ chối";
      case "5":
        return "Hủy duyệt";
    }
  };

  const getStatus2 = (
    text: any,
    effDate?: string | Date,
    expDate?: string | Date
  ): string => {
    const now = new Date();
    const effectiveDate = effDate ? new Date(effDate) : null;
    const expirationDate = expDate ? new Date(expDate) : null;

    switch (text) {
      case "2": // Đã duyệt
        if (effectiveDate && expirationDate) {
          if (now >= effectiveDate && now <= expirationDate) {
            return "Đang chạy";
          } else if (now > expirationDate) {
            return "Hết hiệu lực";
          } else if (now < effectiveDate) {
            return "Chưa đến thời gian chạy";
          }
        }
        return "Đang xét duyệt";
      case "3": // Dừng duyệt
        return "Đang xét duyệt";
      case "4": // Từ chối
        return "Không áp dụng ";
      case "5": // Hủy duyệt
        return "Chưa áp dụng";
      default: // Chưa duyệt
        return "Chưa duyệt";
    }
  };

  const optionColorsStatus: Record<
    "Chưa duyệt" | "Đã duyệt" | "Tạm dừng" | "Từ chối" | "Hủy duyệt",
    string
  > = {
    "Chưa duyệt": "blue",
    "Đã duyệt": "teal",
    "Tạm dừng": "yellow",
    "Từ chối": "red",
    "Hủy duyệt": "gray",
  };

  const renderSelectOptionStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsStatus[
            option.label as
              | "Chưa duyệt"
              | "Đã duyệt"
              | "Tạm dừng"
              | "Từ chối"
              | "Hủy duyệt"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const modalsUpdateListStatus = () => {
    modals.openConfirmModal({
      title: <Title order={5}>Cập nhật trạng thái</Title>,
      size: "auto",
      children: <UpdateListStatus onClose={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const fetchData = async (noti?: string) => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/TblPromotion/get-list?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (
          value &&
          ((typeof value === "string" && value.length > 0) ||
            (Array.isArray(value) && value.length > 0))
        ) {
          params.append(key, String(value));
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${encodeURIComponent(keySearch)}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryDelivery.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
        if (noti) {
          table.resetRowSelection();
        }
        console.log(url);
      }

      if (noti && noti.length > 0) {
        NotificationExtension.Success(noti);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const exportDataExcel = async () => {
    let url = `/api/v1/TblPromotion/export-excel?`;

    const params = new URLSearchParams();
    Object.entries(search).forEach(([key, value]) => {
      if (
        value &&
        ((typeof value === "string" && value.length > 0) ||
          (Array.isArray(value) && value.length > 0))
      ) {
        params.append(key, String(value));
      }
    });

    if (keySearch.length > 0) {
      url += `KeySearch=${encodeURIComponent(keySearch)}&`;
    }

    url += `${params.toString()}&`;

    const _url = BASE_API_DELIVERY + url;
    const token = localStorage.getItem("token");

    const response = await fetch(_url, {
      method: "GET",
      headers: {
        "Content-Type": "application/vnd.ms-excel",
        Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to download file");
    }
    const blob = await response.blob();
    const urlss = window.URL.createObjectURL(blob);
    const _name = new Date().toISOString().slice(0, 10);
    let filename = "danh_sach_khuyen_mai_theo_san_pham.xlsx";
    const link = document.createElement("a");
    link.href = urlss;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const fetchDataEmployee = async () => {
    const res = await getTblDmEmployeeAll();

    if (res) {
      setDataEmployee(
        res
          .filter((item) => item.fullname && item.id)
          .map((item) => ({
            label: `${item.code} - ${item.fullname}`,
            value: item.id?.toString(),
          }))
      );
    }
  };

  const fetchDataInventory = async () => {
    const res = await getTblDMInventory();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value && item.value !== "-1")
        ?.map((item) => ({
          label: item.text?.toString(),
          value: item.value?.toString(),
        }));
      setDataInventory(data);
    }
  };

  useEffect(() => {
    fetchDataEmployee();
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.maCtkm,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "mrt-row-numbers"],
        right: ["tt", "ttDuyet", "action"],
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100", "200"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          {/* <Button
            color="teal"
            leftSection={<IconRefresh size={14} />}
            onClick={() => modalsUpdateListStatus()}
          >
            Cập nhật trạng thái nhiều CTKM
          </Button> */}
          <Flex gap={"md"}>
            <Menu
              closeOnItemClick={false}
              closeOnClickOutside={false}
              opened={openMenu}
              onChange={() => setOpenMenu(!openMenu)}
            >
              <Menu.Target>
                <Button
                  color="teal"
                  leftSection={<IconRefresh size={14} />}
                  disabled={selectIds.length === 0}
                >
                  Cập nhật trạng thái CTKM
                </Button>
              </Menu.Target>
              <Menu.Dropdown>
                <UpdateStatus
                  codes={selectIds}
                  status={""}
                  fetchData={fetchData}
                  setOpenMenu={setOpenMenu}
                />
              </Menu.Dropdown>
            </Menu>
            <Button
              leftSection={<IconFileExport size={14} />}
              onClick={() => exportDataExcel()}
            >
              Export Excel
            </Button>
          </Flex>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Hiệu lực từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.FromDateApprove && search.FromDateApprove?.length > 0
                  ? new Date(search.FromDateApprove ?? "")
                  : null
              }
              maxDate={
                search.ToDateApprove && search.ToDateApprove?.length > 0
                  ? new Date(search.ToDateApprove)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "FromDateApprove",
                  setSearch
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Hiệu lực đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.ToDateApprove && search.ToDateApprove?.length > 0
                  ? new Date(search.ToDateApprove ?? "")
                  : null
              }
              minDate={
                search.FromDateApprove && search.FromDateApprove?.length > 0
                  ? new Date(search.FromDateApprove)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "ToDateApprove",
                  setSearch
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Duyệt từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.FromDateExpired && search.FromDateExpired?.length > 0
                  ? new Date(search.FromDateExpired ?? "")
                  : null
              }
              maxDate={
                search.ToDateExpired && search.ToDateExpired?.length > 0
                  ? new Date(search.ToDateExpired)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "FromDateExpired",
                  setSearch
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Duyệt đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.ToDateExpired && search.ToDateExpired?.length > 0
                  ? new Date(search.ToDateExpired ?? "")
                  : null
              }
              minDate={
                search.FromDateExpired && search.FromDateExpired?.length > 0
                  ? new Date(search.FromDateExpired)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "ToDateExpired",
                  setSearch
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Trạng thái duyệt"
              data={[
                {
                  value: "1",
                  label: "Chưa duyệt",
                },
                {
                  value: "2",
                  label: "Đã duyệt",
                },
                {
                  value: "3",
                  label: "Tạm dừng",
                },
                {
                  value: "4",
                  label: "Từ chối",
                },
                {
                  value: "5",
                  label: "Hủy duyệt",
                },
              ]}
              leftSection={<IconStatusChange color="#15aabf" />}
              onChange={(e) => {
                changeSearchValue(e ? e : "", "Status", setSearch);
              }}
              renderOption={renderSelectOptionStatus}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Kho"
              data={dataInventory}
              searchable
              clearable
              leftSection={<IconBuildingWarehouse color="#15aabf" />}
              onClick={() => {
                if (dataInventory.length === 0) {
                  fetchDataInventory();
                }
              }}
              onChange={(e) =>
                changeSearchValue(e ? e : "", "SubInvId", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Người tạo"
              data={dataEmployee}
              searchable
              clearable
              leftSection={<IconUser color="#15aabf" />}
              onChange={(e) => {
                changeSearchValue(e ? e : "", "EmployeeId", setSearch);
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default ListPromotionByItem;
